import {Routes} from '@angular/router';
import {redirectToLanding, requireAdmin} from './guard-helpers';

export const adminRoutes: Routes = [
	{
		path: 'admin',
		canActivate: [redirectToLanding, requireAdmin],
		children: [
			{
				path: 'profile',
				loadComponent: () => import('../pages/admin/profile-manager/profile-manager.component').then((c) => c.ProfileManagerComponent)
			},
			{
				path: 'room',
				loadComponent: () => import('../pages/admin/room-manager/room-manager.component').then((c) => c.RoomManagerComponent)
			},
			{
				path: 'tchat',
				loadComponent: () => import('../pages/admin/message-manager/message-manager.component').then((c) => c.MessageManagerComponent)
			},
			{
				path: 'reports',
				loadComponent: () => import('../pages/admin/report-manager/report-manager.component').then((c) => c.ReportManagerComponent)
			}
		]
	}
];
